// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HGVpOpORD_zvZ9W5lXge {
  border-radius: var(--form-input-border-radius);
}

.G4BQ25wCfbZASWXtSifg {
  border-radius: var(--form-input-border-radius);
}
`, "",{"version":3,"sources":["webpack://./src/components/FormSelectPhoneCodeCountry/FormSelectPhoneCodeCountry.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":[".selectCountryHeader {\n  border-radius: var(--form-input-border-radius);\n}\n\n.selectCountryList {\n  border-radius: var(--form-input-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectCountryHeader": `HGVpOpORD_zvZ9W5lXge`,
	"selectCountryList": `G4BQ25wCfbZASWXtSifg`
};
export default ___CSS_LOADER_EXPORT___;
